import { array, func, bool, oneOf } from 'prop-types'
import { ThemeProvider } from '@opallabs/hooks'
import { Switch } from '@opallabs/lapidary'
import { kuiperClassNames, renderIcon } from '../../utils'

import './styles.scss'

const ActiveHeader = ({
  disabled,
  enabledFilters,
  onClearFilters,
  onDisableAll,
  value,
}) => (
  <div
    className={kuiperClassNames('active-header', {
      enabled: value.length && enabledFilters.length,
    })}
  >
    {enabledFilters.length && !disabled ? (
      <div>
        {enabledFilters.length} active filter
        {enabledFilters.length === 1 ? null : 's'}
      </div>
    ) : (
      <div>{value.length ? 'No active filters' : 'No filters selected'}</div>
    )}
    {value.length ? (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div
        role="button"
        tabIndex={0}
        className={kuiperClassNames('clear')}
        onClick={onClearFilters}
      >
        {renderIcon('close-sm', {
          width: 9,
          height: 9,
          ariaLabel: 'Clear filters',
          ariaMode: 'presentational',
        })}
      </div>
    ) : null}
    <div className={kuiperClassNames('spacer')} />
    <ThemeProvider theme="light">
      <Switch
        checked={value.length > 0 && !disabled}
        onToggle={onDisableAll}
        readonly={!value.length}
      />
    </ThemeProvider>
  </div>
)
ActiveHeader.displayName = 'Kuiper: ActiveHeader ← FilterBar '

ActiveHeader.propTypes = {
  disabled: bool,
  enabledFilters: array,
  onClearFilters: func,
  onDisableAll: func,
  theme: oneOf(['dark', 'light']),
  value: array,
}

export default ActiveHeader
